import {ProductSummaryToDataLayer} from "@next/eventservice"

const PlpLandingPageEvent = new ProductSummaryToDataLayer()

export const publishProductImpressions = (eventName: string, data: any) => {
    PlpLandingPageEvent.publish({event: eventName, data})
}
